export const SET_THEME = 'SET_THEME'

export const GET_ACTIVE_THEME_STARTED = 'GET_ACTIVE_THEME_STARTED'
export const GET_ACTIVE_THEME_ERROR = 'GET_ACTIVE_THEME_ERROR'
export const GET_ACTIVE_THEME_SUCCESS = 'GET_ACTIVE_THEME_SUCCESS'
